export const SHIFT_SOURCE = {
  UPLOAD: 'UPLOAD',
  INTEGRATION: 'INTEGRATION',
  SALARY: 'SALARY',
};
